module.exports = __webpack_public_path__ + "img/icon_search_total.5a1d6c4c.svg";